// extracted by mini-css-extract-plugin
module.exports = {"base":"ClusterOverview_base__h9ERh","descriptionColumn":"ClusterOverview_descriptionColumn__370hL","chartColumn":"ClusterOverview_chartColumn__2OO84"};